module.exports = __webpack_public_path__ + "static/media/BAT-BNB.5ca0123e.svg";